<template>
	<ListItem
		is-recipient
		:custom-text="text"
	/>
</template>
<script>
import ListItem from "@/vue/communication/conversation/message/ListItem.vue";

export default {
	components: {
		ListItem
	},

	computed: {
		text ()
		{
			return 'Gib bitte rasch bekannt, ob ein Termin für dich passt! Oder schlage andere Termine vor.';
		}
	}
}
</script>
